import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { PragmaticPlayGames } from "../../../../lib/data/pragmaticplayGames.data";
import BackIcon from "../../../../assets/svg/BackIcon";

const PragmaticPlay = () => {
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setFilteredData(Object.values(PragmaticPlayGames));
  }, []);

  return (
    <>
      <HeaderAfterLogin />
      <main className="main slots-section">
        <div className="container">
          <div className="headingSec">
            <h4>Pragmatic Play</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              <BackIcon /> Back
            </div>
          </div>
          <ul className="games-list">
            {filteredData.length > 0 ? (
              filteredData.map((game, idx) => (
                <li key={game.code || idx} className="game-item">
                  <a href={game.redirectUrl || "javascript:void(0)"}>
                    <img src={game.imgUrl} alt={game.name || ""} />
                    <span>{game.name}</span>
                  </a>
                </li>
              ))
            ) : (
              <li>No games available</li>
            )}
          </ul>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default PragmaticPlay;
